module.exports = __webpack_public_path__ + "img/justizlogo.1e8f51bf.png";